/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2022
 * @flow
 */

import React from 'react';
import Button from '../../../../../components/Button';
import Card from '../../Card';
import classes from './RightSection.module.css';
import strings from '../../../../../globalization';

const RightSection = props => {
  const {
    sectionView,
    primarySelectedSection,
    primarySelectedEmployee,
    secondarySelectedSections,
    secondarySelectedEmployees,
    onMerge,
  } = props;

  return (
    <div className={classes.rightSection}>
      <div className={classes.tablesWrapper}>
        {!sectionView ? <SectionView {...props} /> : <EmployeesView {...props} />}
      </div>
      <MergeButton
        sectionView={sectionView}
        primarySelectedSection={primarySelectedSection}
        secondarySelectedSections={secondarySelectedSections}
        primarySelectedEmployee={primarySelectedEmployee}
        secondarySelectedEmployees={secondarySelectedEmployees}
        onMerge={onMerge}
      />
    </div>
  )
};

export default RightSection;

const SectionView = props => {
  const {
    sectionList,
    primarySelectedEmployee,
    secondarySelectedSections,
    onSelectSecondarySection,
    assigned,
    revenueCentersMap,
  } = props;

  const isVisible = section => {
    const { employees } = section;
    let assignedFlag = true;

    if (assigned) {
      assignedFlag = (Array.isArray(employees) && employees.length > 0);
    }

    return (assignedFlag);
  };

  return (
    <>
      {!primarySelectedEmployee ? null :
        sectionList.map(eachSection => {
          const { Section, employees } = eachSection;
          return (!isVisible(eachSection) ? null :
            <Card
              key={Section.id}
              active={secondarySelectedSections.has(Section.id)}
              section={Section}
              isAssigned={(Array.isArray(employees) && employees.length > 0)}
              onClick={onSelectSecondarySection}
              flexBasis={'30%'}
              revenueCentersMap={revenueCentersMap}
            />
          )
        })
      }
    </>
  );
};

const EmployeesView = props => {
  const {
    employeeList,
    primarySelectedSection,
    secondarySelectedEmployees,
    onSelectSecondaryEmployee,
    excludeTerminated,
    jobAllowsAssignment,
    jobsMap,
    assigned,
  } = props;

  const isVisible = empProps => {
    const { employee, Sections } = empProps;
    let terminatedFlag = true, jobTypeFlag = true, jobAllowsAssignmentFlag = true, assignedFlag = true;

    if (excludeTerminated) { //show only employees where terminated = false
      terminatedFlag = employee.terminated === false;
    }

    if (jobAllowsAssignment) { //show employees that have a job and job.allowEmployeeTableAssignment is true
      const empJob = jobsMap.has(employee.jobId) ? jobsMap.get(employee.jobId) : {};
      jobAllowsAssignmentFlag = empJob?.allowEmployeeTableAssignment === true ? true : false;
    }

    if (assigned) {
      assignedFlag = (Array.isArray(Sections) && Sections.length > 0);
    }

    return (terminatedFlag && jobAllowsAssignmentFlag && jobTypeFlag && assignedFlag);
  };

  return (
    <>
      {!primarySelectedSection ? null :
        employeeList.map(eachEmployee => {
          const { employee } = eachEmployee;
          return (
            isVisible(eachEmployee)
              ? <Card
                key={employee.id}
                active={secondarySelectedEmployees.has(employee.id)}
                isEmployee
                employee={employee}
                onClick={onSelectSecondaryEmployee}
                flexBasis={'30%'}
              />
              : null
          )
        })
      }
    </>
  );
};

const MergeButton = ({ sectionView, primarySelectedSection, secondarySelectedSections, primarySelectedEmployee, secondarySelectedEmployees, onMerge }) => {
  const isButtonDisabled = () => {
    if (sectionView) {
      if (!!primarySelectedSection && secondarySelectedEmployees.size !== 0)
        return false;
      return true;
    } else {
      if (!!primarySelectedEmployee && secondarySelectedSections.size !== 0)
        return false;
      return true;
    }
  };

  return (
    <div className={classes.buttonsWrapper}>
      <Button className={classes.btn} onClick={onMerge} disabled={isButtonDisabled()}>
        <span className={classes.mergeTxt}>{strings.assign.toUpperCase()}</span>
      </Button>
    </div>
  );
};
